function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M2.19255 7.70673C1.93614 7.83707 1.93614 8.16293 2.19255 8.29327L11.4233 12.9856C11.6102 13.0806 11.831 12.6861 11.9371 12.3641C11.9963 12.1847 11.8937 12.0101 11.725 11.9252L4.81108 8.44665C4.44405 8.26198 4.44405 7.738 4.81108 7.55334L11.725 4.0748C11.8937 3.98989 11.9963 3.81533 11.9371 3.63589C11.831 3.31394 11.6102 2.9194 11.4233 3.01438L2.19255 7.70673Z",
  fill: "currentColor"
});
const SvgLess = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLess, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/less.286d5369.svg";
export { ForwardRef as ReactComponent };